import React from "react";
import NewsletterThree from "../component/NewsletterThree";

function NewsletterThreeContainers() {
  return <NewsletterThree />;
}

export default NewsletterThreeContainers;
